<p class="mat-body-1" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px" style="padding: 30px;">
    <mat-icon class="icon-lg translucent">cloud_off</mat-icon>
    <label class="translucent">Este recurso foi desabilitado</label>
</p>